import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import createAuthInterceptor from './utils/authInterceptor';
import './i18n'; // Import i18n configuration
import Home from './pages/Home';
import BrowseTemplates from './pages/BrowseTemplates';
import CustomizeGiftCard from './pages/CustomizeGiftCard';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTemplates from './pages/admin/AdminTemplates';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminOrders from './pages/admin/AdminOrders';
import AdminMessages from './pages/admin/AdminMessages';
import AdminAffiliateCoupons from './pages/admin/AdminAffiliateCoupons';
import AdminSettings from './pages/admin/AdminSettings';
import AdminSiteContent from './pages/admin/AdminSiteContent';
import AdminSubscriptionPlans from './pages/admin/AdminSubscriptionPlans';
import AdminRedemptionInstructions from './pages/admin/AdminRedemptionInstructions';
import AdminPasswordReset from './pages/admin/AdminPasswordReset';

function App() {
  // Initialize auth interceptor on app load
  useEffect(() => {
    createAuthInterceptor();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* English Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/browse" element={<BrowseTemplates />} />
        <Route path="/customize/:templateId" element={<CustomizeGiftCard />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/confirmation/:orderId" element={<OrderConfirmation />} />
        
        {/* Russian Routes */}
        <Route path="/browse-ru" element={<BrowseTemplates />} />
        <Route path="/customize-ru/:templateId" element={<CustomizeGiftCard />} />
        <Route path="/checkout-ru" element={<Checkout />} />
        <Route path="/confirmation-ru/:orderId" element={<OrderConfirmation />} />
        
        {/* Kazakh Routes */}
        <Route path="/browse-kz" element={<BrowseTemplates />} />
        <Route path="/customize-kz/:templateId" element={<CustomizeGiftCard />} />
        <Route path="/checkout-kz" element={<Checkout />} />
        <Route path="/confirmation-kz/:orderId" element={<OrderConfirmation />} />
        
        {/* Admin Routes (English only) */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/password-reset" element={<AdminPasswordReset />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/templates" element={<AdminTemplates />} />
        <Route path="/admin/coupons" element={<AdminCoupons />} />
        <Route path="/admin/affiliate-coupons" element={<AdminAffiliateCoupons />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        <Route path="/admin/site-content" element={<AdminSiteContent />} />
        <Route path="/admin/subscription-plans" element={<AdminSubscriptionPlans />} />
        <Route path="/admin/redemption-instructions" element={<AdminRedemptionInstructions />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;